import styled from 'styled-components';
import { Layout } from 'antd';
import variableStyles from '../../constants/variables-styles';

export const LoginContainer = styled(Layout)`
  background: ${variableStyles.primaryBasic};
  height: 100vh;
  overflow: hidden;
  position: relative;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${variableStyles.primaryBasic7};
  }
`;

export const LoginContent = styled(Layout.Content)`
  height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  justify-content: center;
`;

export const LoginBox = styled.div`
  background: ${variableStyles.backgroundBasic};
  max-width: 343px;
  z-index: 1;
  padding: 20px;
  border-radius: 12px;
  .login-text {
    text-align: center;
  }
  .login-form {
    width: 300px;
  }

  .label-change-password {
    cursor: pointer;
    color: #1890ff;
    margin-bottom: 24px;
    text-align: right;
  }
`;
